import React from 'react';
import './wizardInfo.css';
import { VIEW } from '../../assets/Constants/actionsTypes';

import { useTranslation } from 'react-i18next';

// * Icons
import { GiCheckMark } from "react-icons/gi";

/* This component represents the wizard (steps) information. Render at the left of the screen*/
function WizardInfo(props) {
    // we call the hook to make translations
    const { t } = useTranslation('common');

    return (
        <div className="col-md-2 wInfo_column">
            {/*Here just the column, without the container. That's because the container is in the Wizard component*/}
            <ul className="wLists">
                <li className={props.activeStep === 1 ? 'list_elem_active' : 'list_elem_inactive'}>
                    <label className="wLabels_Info"> {props.activeStep === 1 ? <GiCheckMark style={{ marginRight: "3px" }} /> : ''} {t('model.step_1')} </label>
                    <ul className="wLists">
                        <li className="wLists_elements">{t('model.step1_wInfo_title')}</li>
                    </ul>
                </li>
                <li className={props.activeStep === 2 ? 'list_elem_active' : 'list_elem_inactive'}>
                    <label className="wLabels_Info"> {props.activeStep === 2 ? <GiCheckMark style={{ marginRight: "3px" }} /> : ''} {t('model.step_2')} </label>
                    <ul className="wLists">
                        <li className="wLists_elements">{t('model.step2_wInfo_title')}</li>
                    </ul>
                </li>
                <li className={props.activeStep === 3 ? 'list_elem_active' : 'list_elem_inactive'}>
                    <label className="wLabels_Info"> {props.activeStep === 3 ? <GiCheckMark style={{ marginRight: "3px" }} /> : ''} {t('model.step_3')} </label>
                    <ul className="wLists">
                        <li className="wLists_elements">{t('model.step3_wInfo_title')}</li>
                    </ul>
                </li>
                <li className={props.activeStep === 4 ? 'list_elem_active' : 'list_elem_inactive'}>
                    <label className="wLabels_Info"> {props.activeStep === 4 ? <GiCheckMark style={{ marginRight: "3px" }} /> : ''} {t('model.step_4')} </label>
                    <ul className="wLists">
                        <li className="wLists_elements">{t('model.step4_wInfo_title')}</li>
                    </ul>
                </li>
                <li className={props.activeStep === 5 ? 'list_elem_active' : 'list_elem_inactive'}>
                    <label className="wLabels_Info"> {props.activeStep === 5 ? <GiCheckMark style={{ marginRight: "3px" }} /> : ''} {t('model.step_5')} </label>
                    <ul className="wLists">
                        <li className="wLists_elements">{t('model.step5_wInfo_title')}</li>
                    </ul>
                </li>
                <li className={props.activeStep === 6 ? 'list_elem_active' : 'list_elem_inactive'}>
                    <label className="wLabels_Info"> {props.activeStep === 6 ? <GiCheckMark style={{ marginRight: "3px" }} /> : ''} {t('model.step_6')} </label>
                    <ul className="wLists">
                        <li className="wLists_elements">{t('model.step6_wInfo_title')}</li>
                    </ul>
                </li>
                <li className={props.activeStep === 7 ? 'list_elem_active' : 'list_elem_inactive'}>
                    <label className="wLabels_Info"> {props.activeStep === 7 ? <GiCheckMark style={{ marginRight: "3px" }} /> : ''} {t('model.step_7')} </label>
                    <ul className="wLists">
                        <li className="wLists_elements">{t('model.step9_wInfo_title')}</li>
                    </ul>
                </li>
                <li className={props.activeStep === 8 ? 'list_elem_active' : 'list_elem_inactive'}>
                    <label className="wLabels_Info"> {props.activeStep === 8 ? <GiCheckMark style={{ marginRight: "3px" }} /> : ''} {t('model.step_8')} </label>
                    <ul className="wLists">
                        <li className="wLists_elements">{t('model.step7_wInfo_title')}</li>
                    </ul>
                </li>

                <li className={props.activeStep === 9 ? 'list_elem_active' : 'list_elem_inactive'}>
                    <label className="wLabels_Info"> {props.activeStep === 9 ? <GiCheckMark style={{ marginRight: "3px" }} /> : ''} {t('model.step_9')} </label>
                    <ul className="wLists">
                        <li className="wLists_elements">{t('model.step8_wInfo_title')}</li>
                    </ul>
                </li>
                {props.isActionView === VIEW ? null : !props.isModelCompleted ? <li className={props.activeStep === 10 ? 'list_elem_active' : 'list_elem_inactive'}>
                    <label className="wLabels_Info"> {props.activeStep === 10 ? <GiCheckMark style={{ marginRight: "3px" }} /> : ''} {t('model.step_10')} </label>
                    <ul className="wLists">
                        <li className="wLists_elements">{t('model.step10_wInfo_title')}</li>
                    </ul>
                </li> : null}

            </ul>
        </div>
    );
}

export default WizardInfo